// extracted by mini-css-extract-plugin
module.exports = {"important":"DeletePolicyModal__important--3bVFM","notes":"DeletePolicyModal__notes--23DZQ m-list-notes"};